<template>
  <el-tooltip placement="left">
    <div slot="content" class="data-table-th-listname-list">
      <span
        v-for="list_in in list_in"
        class="pointer"
        v-show="list_in.list_id != list_id"
        :key="list_in.list_id"
        style="margin-right:5px"
        @click.exact="referer == 'list' ? changeList(list_in.list_id) : openList(list_in.list_id)"
        @click.ctrl.exact="openNewWindow(list_in.list_id)"
        @click.meta.exact="openNewWindow(list_in.list_id)"
      >
        <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
        {{ list_in.list_name }}
        <br /> </span
      >に追加されています
    </div>
    <span v-if="referer == 'list'">
      <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
      他{{ list_count - 1 }}件のリスト
    </span>
    <span v-else-if="referer == 'list_master'">
      <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
      {{ list_count  }}件のリスト
    </span>
    <span v-else>
      <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
      {{ list_count }}件のリスト
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: "listIn",
  props: ["list_id", "list_in", "list_count", "referer", "member_select"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    openList(id) {
      let routeData = this.$router.resolve({
        name: "listDetail",
        params: {
          list_id: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    changeList(id) {
      this.$router.push({
        name: "listDetail",
        params: {
          list_id: id,
          member_select: this.member_select,
        },
      });
    },
    openNewWindow(id) {
      let routeData = this.$router.resolve({
        name: "listDetail",
        params: {
          list_id: id,
          member_select: this.member_select,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
